let lastLayerZIndex = 999999;

function incrementLastLayerZIndex()
{
    lastLayerZIndex += 2;
}

function getLastLayerZIndex()
{
    return lastLayerZIndex;
}

// is variable defined?
function isDefined(prom)
{
    return ((prom !== undefined) && (typeof prom !== typeof undefined));
}

// Cover overlay
function showCoverLayer(zIndex)
{
    $("#cover-layer").height(getDocHeight()).addClass("visible").css('z-index', zIndex);
}

function hideCoverLayer()
{
    $("#cover-layer").height(0).removeClass("visible");
}

// is variable object?
function isObject(prom)
{
    if (isDefined(prom)) {
        if (typeof prom === 'object') {
            return true;
        }
    }
    return false;
}

// is variable bool?
function isBoolean(prom)
{
    if (isDefined(prom)) {
        if (typeof prom === "boolean") {
            return true;
        }
    }
    return false;
}

// is variable function?
function isFunction(prom)
{
    if (isDefined(prom)) {
        if (typeof prom === 'function') {
            return true;
        }
    }
    return false;
}

function isNumeric(n)
{
    return !isNaN(parseFloat(n)) && isFinite(n);
}

function isFloat(value)
{
    return value.toString().indexOf('.') != -1 || value.toString().indexOf(',') != -1;
}

// generate uniq id
function uniqid()
{
    function s4()
    {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }

    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

// Strings operations
function str_replace(string, pattern, replace, position)
{
    if (!isDefined(string) || !isDefined(pattern) || !isDefined(replace)) {
        console.log("Insufficient number od parameters in function str_replace");
        return;
    }
    if (!isDefined(position)) {
        string = string.replace(new RegExp(pattern, 'g'), replace);
    } else {
        let nth = 0;
        let reg = new RegExp(pattern, "g");
        string = string.replace(reg, function (match, i, original) {
            nth++;
            return (nth === position) ? replace : match;
        });
    }
    return string;
}

function selectAllText(elem)
{
    let range, selection;
    // A jQuery selector should pass through too
    elem = (elem.jquery && elem.length) ? elem[0] : elem;
    if (!elem) {
        return;
    } else if (elem.nodeName.match(/^(INPUT|TEXTAREA)$/i)) {
        elem.focus();
        elem.select();
    } else if (typeof document.body.createTextRange === "function") {
        // IE or Opera <10.5
        range = document.body.createTextRange();
        range.moveToElementText(elem);
        range.select();
    } else if (typeof window.getSelection === "function") {
        selection = window.getSelection();
        if (typeof selection.setBaseAndExtent === "function") {
            // Safari
            selection.setBaseAndExtent(elem, 0, elem, 1);
        } else if (typeof selection.addRange === "function" && typeof selection.removeAllRanges === "function" && typeof document.createRange === "function") {
            // Mozilla or Opera 10.5+
            range = document.createRange();
            range.selectNodeContents(elem);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
}

String.prototype.toDate = function (format) {
    let normalized = this.replace(/[^a-zA-Z0-9]/g, '-');
    let normalizedFormat = format.toLowerCase().replace(/[^a-zA-Z0-9]/g, '-');
    let formatItems = normalizedFormat.split('-');
    let dateItems = normalized.split('-');

    let monthIndex = formatItems.indexOf("mm");
    let dayIndex = formatItems.indexOf("dd");
    let yearIndex = formatItems.indexOf("yyyy");
    let hourIndex = formatItems.indexOf("hh");
    let minutesIndex = formatItems.indexOf("ii");
    let secondsIndex = formatItems.indexOf("ss");

    let today = new Date();

    let year = yearIndex > -1 ? dateItems[yearIndex] : today.getFullYear();
    let month = monthIndex > -1 ? dateItems[monthIndex] - 1 : today.getMonth() - 1;
    let day = dayIndex > -1 ? dateItems[dayIndex] : today.getDate();

    let hour = hourIndex > -1 ? dateItems[hourIndex] : today.getHours();
    let minute = minutesIndex > -1 ? dateItems[minutesIndex] : today.getMinutes();
    let second = secondsIndex > -1 ? dateItems[secondsIndex] : today.getSeconds();

    return new Date(year, month, day, hour, minute, second);
};

// Get document real height
function getDocHeight()
{
    let D = document;
    return Math.max(
        D.body.scrollHeight, D.documentElement.scrollHeight,
        D.body.offsetHeight, D.documentElement.offsetHeight,
        D.body.clientHeight, D.documentElement.clientHeight
    );
}

// Get real container height
function getContainerHeight(element, byElementsInside)
{
    if (!isDefined(byElementsInside)) {
        byElementsInside = false;
    }
    if (byElementsInside) {
        let total = 0;
        element.children().each(function () {
            if ($(this).is(":visible")) {
                total += $(this).outerHeight();
            }
        });
        return total;
    } else {
        return element.outerHeight(true);
    }
}

// files operations
function loadImageFromFile(file, callback)
{
    let reader = new FileReader(file);
    reader.readAsDataURL(file);
    reader.onload = function (e) {
        let img = new Image();
        let origH;
        let origW;
        img.src = e.target.result;
        img.onload = function () {
            origH = this.height;
            origW = this.width;
            if (origH > origW) {
                img.height = 150;
            }
            callback(img);
        };
        img.onerror = function () {
            callback(null);
        };
    };
}

function getFileInfo(file)
{
    return {
        basename: file.name.replace(/\\/g, '/').replace(/.*\//, ''),
        extension: file.name.split('.').pop().toLowerCase(),
        size: (file.size / 1024) / 1024
    };
}

function textAreaAdjust(o)
{
    o.style.height = "1px";
    o.style.height = (25 + o.scrollHeight) + "px";
}

/* Change default options to defined options */

function parseOptions(options_def, options_new)
{

    $.each(options_new, function (property, value) {
        $.each(options_def, function (prop, val) {
            if (prop === property) {
                if ((!isDefined(val) || val == null) && isDefined(value)) {
                    options_def[prop] = value;
                } else {
                    if (isObject(val) && isObject(value)) {
                        if (Array.isArray(val) && Array.isArray(value)) {
                            options_def[prop] = value;
                        } else {
                            parseOptions(val, value);
                        }
                    } else {
                        if (isObject(val) && !isObject(value)) {
                            console.log("Wrong option value, it must be object: " + prop + "");
                        } else {
                            if (isDefined(value)) {
                                if (value === "true" || value === "false") {
                                    options_def[prop] = (value === 'true');
                                } else {
                                    if (value !== "") {
                                        options_def[prop] = value;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        });
    });
}

// init CK 5 editor

function initCK5Editor(targetElement, callback)
{

    ClassicEditor.create(targetElement, {

        toolbar: {
            items: [
                'removeFormat',
                '|',
                'heading',
                'bold',
                'italic',
                'subscript',
                'superscript',
                'fontColor',
                '|',
                'undo',
                'redo',
                '|',
                'blockQuote',
                'alignment',
                'indent',
                'outdent',
                '|',
                'bulletedList',
                'numberedList',
                '|',
                'specialCharacters',
                'insertTable',
                'mediaEmbed',
                'link',
                'horizontalLine',
                '|'
            ]
        },
        heading: {
            options: [
                {
                    model: 'paragraph',
                    title: 'Paragraph',
                    class: ''
                },
                {
                    model: 'heading2',
                    view: 'h2',
                    title: 'Nadpis 2. úrovně',
                    class: ''
                },
                {
                    model: 'heading3',
                    view: 'h3',
                    title: 'Nadpis 3. úrovně',
                    class: ''
                }
            ]
        },
        link: {
            addTargetToExternalLinks: true,
            decorators: {
                /*toggleDownloadable: {
                    mode: 'manual',
                    label: 'Downloadable',
                    attributes: {
                        download: 'file'
                    }
                },*/
                openInNewTab: {
                    mode: 'manual',
                    label: 'Otevřít v novém okně',
                    defaultValue: true,			// This option will be selected by default.
                    attributes: {
                        target: '_blank',
                        rel: 'noopener noreferrer'
                    }
                }
            }
        },
        language: 'cs',
        table: {
            contentToolbar: [
                'tableColumn',
                'tableRow',
                'mergeTableCells'
            ]
        },
        licenseKey: '',

    }).then(editor => {

        $(targetElement).data('instance', editor);

        if (isFunction(callback)) {
            callback(editor);
        }


    }).catch(error => {
        console.error('Oops, something went wrong!');
        console.error('Please, report the following error on https://github.com/ckeditor/ckeditor5/issues with the build id and the error stack trace:');
        console.warn('Build id: ylol7gd8zjhu-wo8rg650csgs');
        console.error(error);
    });

}

// Custom URL

var CustomURL = function (url) {

    url = ((isDefined(url)) ? url : window.location.href);

    var BaseUrl;
    var UrlGetParams = {};

    var self = this;

    function getParams()
    {
        var split = url.split("?");
        BaseUrl = split[0];
        if (isDefined(split[1])) {
            var getParams = split[1].split('&');
            for (var i = 0; i < getParams.length; i++) {
                var getParam = getParams[i].split('=');
                UrlGetParams[getParam[0]] = getParam[1];
            }
        }
    }

    function constructGetPart()
    {
        var getPart = "";

        if (Object.keys(UrlGetParams).length > 0) {
            getPart += "?";
        }

        var i = 0;
        $.each(UrlGetParams, function (key, val) {
            getPart += ((i > 0) ? "&" : "") + key + "=" + val;
            i++;
        });

        return getPart;
    }

    function constructUrl()
    {
        return BaseUrl + constructGetPart();
    }

    this.changeUrl = function (url) {
        if (isDefined(url)) {
            self.url = url;
            clear();
            getParams();
        }
    };

    var clear = function () {
        UrlGetParams = {};
    };

    this.getParameters = function () {
        return UrlGetParams;
    };

    this.getBaseUrl = function () {
        return BaseUrl;
    };

    this.getFullUrl = function () {
        return constructUrl();
    };

    this.useThisUrl = function (title, noreload) {

        if (!isBoolean(noreload)) {
            noreload = false;
        }

        var UrlConstruct = constructUrl();

        if (noreload) {
            if (typeof (history.pushState) !== "undefined") {
                var obj = {
                    Title: title,
                    Url: UrlConstruct
                };
                history.pushState(obj, obj.Title, UrlConstruct);
            } else {
                location.replace(UrlConstruct);
            }
        } else {
            location.replace(UrlConstruct);
        }
    };

    this.parameterExists = function (name) {
        return isDefined(UrlGetParams[name]);
    };

    this.addParameter = function (name, value) {
        if (!self.parameterExists(name)) {
            UrlGetParams[name] = value;
        } else {
            self.changeParameter(name, value);
        }
    };

    this.changeParameter = function (name, value) {
        if (self.parameterExists(name)) {
            UrlGetParams[name] = value;
        }
    };

    this.getUrlParameter = function (name) {
        if (self.parameterExists(name)) {
            return UrlGetParams[name];
        } else {
            return false;
        }
    };

    getParams();
};

// confirmFunction

function confirmEvent(event, triggerTarget, callback, showBar = true)
{

    event.preventDefault();
    let ask = "Opravdu chcete odebrat tento záznam?";

    if (isDefined(triggerTarget.data("ask"))) {
        ask = triggerTarget.data("ask");
    }

    let title = 'Odebrání záznamu';
    if (isDefined(triggerTarget.data('title'))) {
        title = triggerTarget.data('title');
    }

    let confirmDialog = new ConfirmDialog(ask, {
        event: event,
        button: triggerTarget
    });

    if (showBar) {
        confirmDialog.barTitle = title;
    } else {
        confirmDialog.showBar = false;
    }

    confirmDialog.barTitle = title;

    confirmDialog.create(function (dialog) {

        if (!showBar) {
            dialog.find('.navbar').remove();
        }

        confirmDialog.open(function (result) {

            if (result) {
                callback(result);
            }

        });
    });

}

(function ($) {

    $.fn.batchImageLoad = function (options) {
        var images = $(this);
        var originalTotalImagesCount = images.length;
        var totalImagesCount = originalTotalImagesCount;
        var elementsLoaded = 0;

        // Init
        $.fn.batchImageLoad.defaults = {
            loadingCompleteCallback: null,
            imageLoadedCallback: null
        };

        var opts = $.extend({}, $.fn.batchImageLoad.defaults, options);

        // Start
        images.each(function () {
            if ($(this)[0].complete) {
                totalImagesCount--;
                if (opts.imageLoadedCallback) opts.imageLoadedCallback(elementsLoaded, originalTotalImagesCount);
                // The image is loading, so attach the listener
            } else {
                $(this).on('load', function () {
                    elementsLoaded++;
                    if (opts.imageLoadedCallback) opts.imageLoadedCallback(elementsLoaded, originalTotalImagesCount);
                    // An image has been loaded
                    if (elementsLoaded >= totalImagesCount)
                        if (opts.loadingCompleteCallback) opts.loadingCompleteCallback();
                });
                $(this).on('error', function () {
                    elementsLoaded++;
                    if (opts.imageLoadedCallback) opts.imageLoadedCallback(elementsLoaded, originalTotalImagesCount);
                    // The image has errored
                    if (elementsLoaded >= totalImagesCount)
                        if (opts.loadingCompleteCallback) opts.loadingCompleteCallback();
                });
            }
        });
        // There are no unloaded images
        if (totalImagesCount <= 0)
            if (opts.loadingCompleteCallback) opts.loadingCompleteCallback();
    };

    $.fn.centerIntoParent = function (parent) {

        let elem = $(this);

        if (!isDefined(parent.css("position"))) {
            parent.css({"position": "relative"});
        }

        function reposition()
        {
            let parenTop = parent.offset().top;
            let parentHeight = getContainerHeight(parent);
            let parentWidth = parent.outerWidth(true);
            let winTop = $(window).scrollTop();
            let winHeight = $(window).height();
            let elemHeight = getContainerHeight(elem);
            let elemWidth = elem.outerWidth(true);
            let visible;
            let cut;
            let top = 0;

            if (winTop < parenTop) {
                cut = 0;
                if ((winTop + winHeight) >= parenTop) {
                    if ((winTop + winHeight) > (parenTop + parentHeight)) {
                        visible = winHeight - (parenTop - winTop) - ((winTop + winHeight) - (parenTop + parentHeight));
                    } else {
                        visible = winHeight - (parenTop - winTop);
                    }
                } else {
                    visible = 0;
                }
                if (visible > 0) {
                    if (visible > elemHeight) {
                        top = cut + (visible / 2) - elemHeight / 2;
                    }
                }
            } else {
                top = parentHeight - elemHeight;
                if (winTop <= parenTop + parentHeight) {
                    cut = winTop - parenTop;
                    if ((winTop + winHeight) > (parenTop + parentHeight)) {
                        visible = winHeight - ((winTop + winHeight) - (parenTop + parentHeight));
                    } else {
                        visible = winHeight;
                    }
                } else {
                    visible = 0;
                }
                if (visible > 0) {
                    if (visible > elemHeight) {
                        top = cut + (visible / 2) - elemHeight / 2;
                    }
                }
            }

            let left = (parentWidth / 2) - (elemWidth / 2);

            elem.css({
                "position": "absolute",
                "top": top,
                "left": left
            });
        }

        $(window).scroll(function () {
            reposition();
        });

        reposition();
    };

    $.fn.centerToScreen = function () {
        let elem = $(this);
        elem.css({
            "position": "fixed",
            "top": ($(window).height() / 2 - getContainerHeight($(this)) / 2),
            "left": ($(window).width() / 2 - $(this).outerWidth(true) / 2)
        });
    };

    $.fn.hasAttr = function (name) {
        return this.attr(name) !== undefined;
    };

    $.fn.isElementVisible = function () {

        let elem = $(this);

        if (elem.is('body')) {
            return true;
        }

        if (!elem.is(':visible')) {
            return false;
        }

        if (elem.css('visibility') === "hidden") {
            return false;
        }

        if (parseInt(elem.css('opacity')) === 0) {
            return false;
        }

        if (elem.width() === 0 || elem.height() === 0) {
            return false;
        }

        if (!elem.parent().isVisible()) {
            return false;
        }

        return true;
    };


    $.fn.moveTop = function () {

        let elem = $(this);
        let duration = 800;
        let offset = 220;

        $(window).scroll(function () {
            if ($(window).scrollTop() > offset) {
                elem.fadeIn(duration);
            } else {
                elem.fadeOut(duration);
            }
        });

        elem.click(function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, duration);
        });
    };

    $.fn.optimusEditor = function (clickedOptionCallback, clickedButtonCallback) {

        var container = $(this);
        var Editor;

        function initEditorOptions(target, callback)
        {
            target.find(">.navbar.editor-theme .navbar-group, table .editor-row .editor-col > .navbar.editor-theme .navbar-group").each(function () {

                let group = $(this);
                let iterator = 1;

                group.find(".navbar-item").each(function () {
                    $(this).data("optionIndex", iterator);
                    iterator++;
                }).on("click", function (e) {

                    e.preventDefault();
                    var option = $(this);

                    if (group.hasClass("single-active")) {
                        option.siblings().removeClass("active");
                        if (option.hasClass("active")) {
                            option.removeClass("active");
                        } else {
                            option.addClass("active");
                        }
                    } else if (group.hasClass("multi-active")) {
                        if (option.hasClass("active")) {
                            option.removeClass("active");
                        } else {
                            option.addClass("active");
                        }
                    } else {
                        console.log("No group type defined");
                    }

                    callback(option.find('.option'), option.hasClass('active'), e);

                });
            });
        }

        function detectEditorContentButtons(target, callback)
        {
            target.find('a.button, input[type="submit"]').on("click", function (e) {
                callback($(this), $(this).hasClass('active'), e);
            });
        }

        if (container.hasClass("editor")) {

            var instance;

            if (!isDefined(container.data("instance"))) {

                Editor = {
                    container: container,
                    firstInit: true,

                    moveToContent: function (target) {
                        if (target.find(">.edit-content").length) {
                            return target.find(">.edit-content");
                        } else {
                            return target.find(".editor-table");
                        }
                    },

                    init: function () {
                        let self = this;

                        initEditorOptions(self.container, function (option, isActive, event) {
                            clickedOptionCallback(option, isActive, event, self.moveToContent(self.container));
                        });

                        if (isFunction(clickedButtonCallback)) {
                            detectEditorContentButtons(self.moveToContent(self.container), function (btn, isActive, event) {
                                clickedButtonCallback(btn, isActive, event, self.moveToContent(self.container));
                            });
                        }

                    }
                };

                Editor.init();
                container.data("instance", Editor);

            } else {

                instance = container.data("instance");

                if (instance.firstInit) {

                    if (isFunction(clickedButtonCallback)) {
                        detectEditorContentButtons(instance.moveToContent(instance.container), function (btn, isActive, event) {
                            clickedButtonCallback(btn, isActive, event, instance.moveToContent(instance.container));
                        });
                    }

                    instance.firstInit = false;
                    container.data("instance", instance);
                }
            }
        }

    };

})(jQuery);

(function (window, $, undefined) {

    if (typeof $ !== 'function') {
        return console.error('jQuery is missing, load it please');
    }

    $.progress = {

        insert: function (target, icon = '<i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>') {

            let $progress;

            if (!isDefined(target)) {
                target = $("body");
            }

            if ((target).is($("body"))) {

                let lastZ = getLastLayerZIndex();

                showCoverLayer(lastZ - 1);

                $progress = $('' +
                    '<div class="progress-dialog visible">' +
                    '<div class="progress">' +
                    '<div class="progress-body filled">' +
                    '<div class="icon">' +
                    icon +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '</div>' +
                    '');

                $progress.css('z-index', lastZ);

                incrementLastLayerZIndex();
                $("body").append($progress);

            } else {

                $progress = $('' +
                    '<div class="progress"> ' +
                    '<div class="progress-body filled"> ' +
                    '<div class="icon">' +
                    icon +
                    '</div>' +
                    '</div> ' +
                    '</div>' +
                    '');

                if (target.css("position").toString() === "static") {
                    target.css({"position": "relative"});
                }
                target.append($progress);
                $progress.css({
                    "position": "absolute",
                    "top": 0,
                    "left": 0
                });
                $progress.find(".icon").centerIntoParent($progress.find(".progress-body"));
            }
            return $progress;
        },

        remove: function (progress) {
            if (isObject(progress)) {
                progress.remove();
                hideCoverLayer();
            }
        }

    };

    $.progressBar = {

        insert: function (target) {

            if (isObject(target)) {

                $progress = $('' +
                    '<div class="progress-bar">' +
                    '<div class="progress-body">' +
                    '<div class="percentage">0&nbsp;%</div>' +
                    '<div class="progress-completed"></div>' +
                    '</div>' +
                    '</div>');

                target.append($progress);
                return $progress;
            }
        },

        update: function (progress, percent) {
            if (isObject(progress)) {
                progress.find(".percentage").html(percent + "&nbsp;%");
                let body = progress.find(".progress-body");
                let size = (body.outerWidth(true) * percent) / 100;
                progress.find(".progress-completed").width(size);
            }
        },

        remove: function (progress) {
            if (isObject(progress)) {
                progress.remove();
            }
        },

        removeInto: function (target) {
            if (isObject(target)) {
                target.find(".progress-bar").remove();
            }
        }

    };

    $.inlineMessages = {
        createGroup: function (target) {
            let group = $('<div class="messages"></div>');
            target.append(group);
            return group;
        },
        insertMessage: function (group, msg, type, duration) {

            let icon = null;

            switch (type) {
                case 'error':
                    icon = '<i class="iz iz-red-cross"></i>';
                    break;
                case 'warning':
                    icon = '<i class="iz iz-warning-yellow"></i>';
                    break;
                case 'success':
                default:
                    icon = '<i class="iz iz-check-ok></i>';
                    break;
            }

            let message = $('<div class="message ' + type + '"><div class="content-wrap">' + icon + msg + '</div>');
            group.append(message);

            if (isDefined(duration)) {
                setTimeout(function () {
                    message.fadeOut(300, function () {
                        message.remove();
                    });
                }, duration);
            }
        },
        removeGroup: function (group) {
            group.remove();
        }
    };

})(window, window.jQuery);

const ProgressDialog = function () {

    let progressDialogElement = null;
    let message = null;

    Object.defineProperties(this, {
        progressDialogElement: {
            get: function () {
                return progressDialogElement;
            },
            set: function (el) {
                if (isObject(el) && progressDialogElement == null) {
                    progressDialogElement = el;
                }
            }
        },
        message: {
            get: function () {
                return message;
            },
            set: function (msg) {
                message = msg;
            }
        }
    });

};

ProgressDialog.prototype.init = function () {

    let lastZ = getLastLayerZIndex();
    showCoverLayer(lastZ - 1);

    let progressDialog = $(`
        <div class="progress-dialog visible">
            <div class="progress">
                <div class="progress-body filled">
                    <div class="icon">
                        <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                    </div>
                    ${this.message ? '<div class="msg">' + this.message + '</div>' : ''}
                </div>
            </div>
        </div>
        `);

    progressDialog.css('z-index', lastZ);

    this.progressDialogElement = progressDialog;

    incrementLastLayerZIndex();
    $("body").append(progressDialog);

};

ProgressDialog.prototype.remove = function () {
    this.progressDialogElement.remove();
    hideCoverLayer();
};